/**
 * Portal ICAVI - Serviço de domínio: Pontos de Embarque
 * Extraído de apiService.ts para reduzir o tamanho do módulo monolítico (RF-07).
 */
import axios from 'axios';
import { api } from '../apiClient';
export const pontosServiceMethods = {
    /**
     * Busca lista de pontos, opcionalmente filtrados por cidade
     */
    async getPontos(cidade = null) {
        try {
            const url = cidade ? `/api/pontos?cidade=${encodeURIComponent(cidade)}` : '/api/pontos';
            const response = await api.get(url);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao buscar pontos:', error);
            throw error;
        }
    },
    /**
     * Adiciona um novo ponto
     */
    async addPonto(ponto) {
        try {
            const response = await api.post('/api/ponto', ponto);
            return response.data;
        }
        catch (error) {
            console.error('Erro ao adicionar ponto:', error);
            if (axios.isAxiosError(error) && error.response?.data) {
                return error.response.data;
            }
            throw error;
        }
    },
};
